import { useState } from 'react';

const useDisclosure = () => {
	const [isOpen, setIsOpen] = useState(false);

	const onClose = () => setIsOpen(false);
	const onOpen = () => setIsOpen(true);
	return { isOpen, onOpen, onClose };
};

export default useDisclosure;
